import { render } from "./AppMenuBar.vue?vue&type=template&id=4e45bdea"
import script from "./AppMenuBar.vue?vue&type=script&lang=js"
export * from "./AppMenuBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__